<template>
  <div
    class="auth-wrapper pr-15 pl-15"
    :style="{
      backgroundImage: 'url(' + $store.getters[`customization/loginBg`] + ')'
    }"
  >
    <div class="language">
      <LanguageBar />
    </div>
    <b-row class="register-form" :class="invitationInfo ? 'w-500' : ''">
      <b-col class="register-content-col">
        <img class="logo-image" :src="$store.getters[`customization/logo`]" />
        <!-- If there are invitation information, then show invitation content -->
        <div v-if="invitationInfo" class="invitation-info">
          <div class="mode-selection">
            <div class="mode-selection-item">
              <div class="mode-item-title">
                {{ $t('text.invitation').toUpperCase() }}
              </div>
              <div class="mode-item-desc">
                <div>
                  <b>{{ invitationInfo.username }}</b>
                  {{ $t('text.has_invited') }}
                  <b>{{ invitationInfo.email }}</b> {{ $t('text.to_join') }}
                  <b>{{ invitationInfo.organisationName }}</b
                  >.
                </div>
                {{ $t('text.invitation_desc') }}
              </div>
              <el-button
                class="mode-item-btn"
                :loading="loading"
                @click="signIn()"
                >{{ $t('text.sign_in') | capitalize }}</el-button
              >
              <div class="mt-20 text-right">
                {{ $t('text.if_not_please') }}
                <span class="text-a cursor-pointer" @click="signUp()">{{
                  $t('text.sign_up').toLowerCase()
                }}</span
                >.
              </div>
            </div>
          </div>
        </div>

        <div
          class="mode-selection"
          v-if="!invitationInfo && !showVerifyMfaSection"
        >
          <div class="mode-selection-item">
            <div class="mode-item-title">
              {{ $t('text.already_registered') }}?
            </div>
            <div class="mode-item-desc">
              {{ $t('text.already_registered_desc') }}
            </div>
            <el-button
              class="mode-item-btn"
              :loading="loading"
              @click="signIn()"
              >{{ $t('text.sign_in') | capitalize }}</el-button
            >
          </div>
          <div class="mode-selection-item">
            <div class="mode-item-title">{{ $t('text.create_account') }}</div>
            <div class="mode-item-desc">
              {{ $t('text.create_account_desc') }}
            </div>
            <el-button
              class="mode-item-btn"
              @click="signUp()"
              :loading="signUpLoading"
              >{{ $t('text.sign_up').toUpperCase() }}</el-button
            >
          </div>
        </div>
        <div class="forgot-password" @click="forgotPassword()">
          {{ $t('text.forgot_password') }}?
        </div>
        <VerifyMfaCode
          ref="verifyMfaCode"
          v-if="showVerifyMfaSection"
          @success="afterVerifyUser"
        />
        <CompleteOrganisationInfo ref="completeOrganisationInfo" :code="code" />
        <OrganisationSelection
          ref="organisationSelection"
          :organisations="organisations"
          @assignPermissionSuccess="redirectToHomePage"
        />
      </b-col>
    </b-row>
  </div>
</template>

<script>
import LanguageBar from '@/components/LanguageBar.vue'
import CompleteOrganisationInfo from '@/components/signIn/CompleteOrganisationInfo.vue'
import OrganisationSelection from '@/components/signIn/OrganisationSelection.vue'
import VerifyMfaCode from '@/components/signIn/VerifyMfaCode.vue'
import { azureAD } from '@/const'
import { encode as base64encode } from 'base64-arraybuffer'
import randomstring from 'randomstring'
import '@/assets/font/font.css'
import '@/assets/css/login.scss'
import '@/assets/css/global.scss'
import $ from 'jquery'
import { identifyUser, captureLogin } from '@/plugins/posthog'
export default {
  data() {
    return {
      code: '',
      loading: false,
      signUpLoading: false,
      token: '',
      accessToken: '',
      organisations: [],
      fullScreenLoading: null,
      fromApp: false,
      informationFromApp: {
        // if mobile app redirect to dashboard site, url will with below information
        accessToken: null,
        organisationId: null,
        to: null,
        deviceToken: null
      },
      showVerifyMfaSection: false,
      resetPasswordLoading: false
    }
  },
  components: {
    LanguageBar,
    CompleteOrganisationInfo,
    OrganisationSelection,
    VerifyMfaCode
  },
  watch: {
    loading() {
      if (this.loading && (this.code || this.fromApp)) {
        this.showFullScreenLoading()
      } else {
        this.closeFullScreenLoading()
      }
    },
    signUpLoading() {
      if (this.signUpLoading && (this.code || this.fromApp)) {
        this.showFullScreenLoading()
      } else {
        this.closeFullScreenLoading()
      }
    },
    resetPasswordLoading() {
      if (this.resetPasswordLoading && (this.code || this.fromApp)) {
        this.showFullScreenLoading()
      } else {
        this.closeFullScreenLoading()
      }
    }
  },
  computed: {
    invitationInfo() {
      // invitation basic information
      // {
      //         invitationCode: data.invitationCode,
      //         organisationId: '11111',
      //         organisationName: `Lucille Wang's Elderly Care Center`,
      //         username: 'Lucille Wang',
      //         email: '2392657090@qq.com'
      //       }
      let invitationInfo =
        JSON.parse(localStorage.getItem('invitationInfo')) || null
      return invitationInfo
    }
  },
  mounted() {
    // Compatible in Safari browser, click the sign in and sign up buttons. After returning to this page, the button keeps loading
    $(window).bind('pageshow', () => {
      this.loading = false
      this.signUpLoading = false
    })
    if (this.$route.query) {
      if (this.$route.query.from && this.$route.query.from === 'app') {
        this.fromApp = true
        this.informationFromApp = {
          accessToken: this.$route.query.code || null,
          organisationId: this.$route.query.organisationId || null,
          to: this.$route.query.to || null,
          deviceToken: this.$route.query.deviceToken || null
        }
        if (this.informationFromApp.deviceToken) {
          this.$store.commit(
            'user/SET_DEVICE_TOKEN',
            this.informationFromApp.deviceToken
          )
        }
        // from app, link will add access token and from app params, then redirect to dashboard, not run Azure AD workflow
        this.appLogin()
        return false
      }
      if (this.$route.query.code) {
        // If code is returned, code is used to exchange for token
        this.code = this.$route.query.code
        this.getAzureToken()
      } else if (this.$route.query.error_description) {
        // If an error message is returned, an error message is displayed
        let errMsg = this.$route.query.error_description
        errMsg = errMsg.substring(
          errMsg.indexOf(':') + 1,
          errMsg.indexOf('Correlation ID')
        )
        this.showErrorMsg(errMsg)
      }
    }
  },
  methods: {
    async generateCodeChallenge(codeVerifier) {
      const encoder = new TextEncoder()
      const data = encoder.encode(codeVerifier)
      const digest = await window.crypto.subtle.digest('SHA-256', data)
      const base64Digest = base64encode(digest)
      return base64Digest
        .replace(/\+/g, '-')
        .replace(/\//g, '_')
        .replace(/=/g, '')
    },
    signUp() {
      this.signUpLoading = true
      const codeVerifier = randomstring.generate(128)
      localStorage.setItem('codeVerifier', codeVerifier)
      this.generateCodeChallenge(codeVerifier).then(challenge => {
        const currentLocale = this.$store.state.locale.currentLocale
        this.$store.commit('user/SET_POLICY', azureAD.signUpPolicy)
        window.open(
          `${azureAD.hostName}/${azureAD.tenantId}/oauth2/v2.0/authorize?p=${azureAD.signUpPolicy}&client_id=${azureAD.clientId}&nonce=defaultNonce&redirect_uri=${window.location.origin}/sign-in&scope=openid&response_type=code&prompt=login&ui_locales=${currentLocale}&code_challenge=${challenge}&code_challenge_method=S256`,
          '_self'
        )
      })
    },
    signIn() {
      this.loading = true
      const codeVerifier = randomstring.generate(128)
      localStorage.setItem('codeVerifier', codeVerifier)
      this.generateCodeChallenge(codeVerifier).then(challenge => {
        this.$store.commit('user/SET_POLICY', azureAD.policy)
        window.open(
          `${azureAD.hostName}/${azureAD.tenantId}/${azureAD.policy}/oauth2/v2.0/authorize?client_id=${azureAD.clientId}&response_type=code&redirect_uri=${window.location.origin}/sign-in&response_mode=query&scope=${azureAD.clientId}%20offline_access&code_challenge=${challenge}&code_challenge_method=S256`,
          '_self'
        )
      })
    },
    calcLoading(isLoading) {
      if (
        !localStorage.getItem('currentPolicy') ||
        localStorage.getItem('currentPolicy') === azureAD.policy
      ) {
        this.loading = isLoading
      } else if (
        localStorage.getItem('currentPolicy') === azureAD.signUpPolicy
      ) {
        this.signUpLoading = isLoading
      } else {
        this.resetPasswordLoading = isLoading
      }
    },
    getAzureToken() {
      this.calcLoading(true)
      this.$store
        .dispatch('user/getAzureToken', this.code)
        .then(() => {
          this.calcLoading(false)
          if (this.invitationInfo) {
            // If it there is invitation information, then go to verify invitation page to complete invitation work flow
            this.calcLoading(true)
            this.$store.dispatch('user/verifyUser').then(() => {
              this.calcLoading(false)

              // if user is in sign up process, then go to receive notification page, after this got to verify invitation page
              if (
                localStorage.getItem('currentPolicy') &&
                localStorage.getItem('currentPolicy') === azureAD.signUpPolicy
              ) {
                this.$router.push('/receive-notification')
              } else {
                // if user is in sign in process, then go to verify invitation page
                this.$router.push({
                  path: '/verify-invitation',
                  query: {
                    completeSignIn: 1
                  }
                })
              }
            })
          } else {
            if (
              !localStorage.getItem('currentPolicy') ||
              localStorage.getItem('currentPolicy') === azureAD.policy ||
              localStorage.getItem('currentPolicy') ===
                azureAD.forgotPasswordPolicy
            ) {
              this.verifyUser()
            } else {
              this.$router.push('/receive-notification')
            }
          }
        })
        .catch(() => {
          this.calcLoading(false)
        })
    },
    verifyUser() {
      this.calcLoading(true)
      this.$store
        .dispatch('user/verifyUser')
        .then(response => {
          this.calcLoading(false)
          if (response.data.success) {
            this.organisations = response.data.data.Organisations
            // User completed the interactive sign-in UI.
            identifyUser(this.$store)
            captureLogin('interactive')
            let isMultiFactorEnabled = response.data.data.IsMultiFactorEnabled
            // In sign in process
            // If the user does not verify mfa or does not trust the browser and multi factor is enabled, you need to verify mfa first
            if (
              (!this.$store.getters[`user/haveTrustBrowser`] ||
                !this.$store.getters[`user/haveVerifyMfa`]) &&
              isMultiFactorEnabled
            ) {
              this.showVerifyMfaSection = true
            } else {
              this.afterVerifyUser()
            }
          } else {
            if (response.data.errorcode === 804) {
              this.handleOrgErr()
            } else {
              this.showErrorMsg(response.data.msg)
            }
          }
        })
        .catch(() => {
          this.calcLoading(false)
        })
    },
    afterVerifyUser() {
      if (this.organisations.length > 1) {
        if (this.fromApp) {
          this.switchToSelectedOrganisation()
          // go to the page that app url to
          if (this.informationFromApp.to) {
            this.toToPage()
          } else {
            this.redirectToHomePage()
          }
        } else {
          this.showOrganisationSelection()
        }
      } else {
        this.redirectToHomePage()
      }
    },
    switchToSelectedOrganisation() {
      if (this.informationFromApp.organisationId) {
        let selectedOrganisation = this.organisations.filter(organisation => {
          return (
            organisation.OrganisationName.OrganisationId ===
            this.informationFromApp.organisationId
          )
        })
        if (selectedOrganisation.length) {
          this.$store.dispatch('user/assignPermission', selectedOrganisation[0])
        } else {
          this.$store.dispatch('user/assignPermission', this.organisations[0])
        }
      } else {
        this.$store.dispatch('user/assignPermission', this.organisations[0])
      }
    },
    toToPage() {
      this.calcLoading(true)
      this.$store.dispatch('patient/fetchPatients').then(() => {
        this.$store.dispatch('filter/getUserFilter').then(response => {
          this.calcLoading(false)
          if (response instanceof Error) {
            this.showErrorMsg('Login Failed')
          } else {
            this.$router.push({
              path: this.informationFromApp.to
            })
          }
        })
      })
    },
    redirectToHomePage() {
      this.calcLoading(true)
      this.$store.dispatch('patient/fetchPatients').then(() => {
        this.$store.dispatch('filter/getUserFilter').then(response => {
          this.calcLoading(false)
          if (response instanceof Error) {
            this.showErrorMsg('Login Failed')
          } else {
            this.$router.push({
              path: this.$store.state.patient.patients.length
                ? '/care-plus-dashboard'
                : '/'
            })
          }
        })
      })
    },
    showErrorMsg(msg) {
      let warningIconUrl = require('@/assets/image/warning-icon/warning.svg')
      this.$confirm(
        `<div class='warning-content'>${msg}</div>` +
          `<img class='warning-icon' src=${warningIconUrl}>`,
        this.$t('text.sign_in_failed'),
        {
          confirmButtonText: this.$t('text.ok').toUpperCase(),
          confirmButtonClass: 'confirm-btn',
          type: 'warning',
          customClass: 'delete-warning-box',
          showClose: true,
          closeOnClickModal: false,
          dangerouslyUseHTMLString: true,
          showCancelButton: false
        }
      )
    },
    handleOrgErr() {
      this.$refs.completeOrganisationInfo.openDialog()
    },
    showOrganisationSelection() {
      this.$refs.organisationSelection.openDialog()
    },
    getErrorMsg(code) {
      let msg = null
      switch (code) {
        case 620:
          msg = this.$t('text.verify_error_msg_620')
          break
        case 622:
          msg = this.$t('text.verify_error_msg_622')
          break
      }
      return msg
    },
    showFullScreenLoading() {
      this.fullScreenLoading = this.$loading({
        lock: true,
        text: this.$t('text.signing_in'),
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
    },
    closeFullScreenLoading() {
      if (this.fullScreenLoading) {
        this.fullScreenLoading.close()
      }
    },
    appLogin() {
      if (!this.informationFromApp.accessToken) {
        this.showErrorMsg('Miss access token!')
        return false
      }
      this.calcLoading(true)
      this.$store
        .dispatch('user/appLogin', this.informationFromApp.accessToken)
        .then(() => {
          this.calcLoading(false)
          this.verifyUser()
        })
        .catch(() => {
          this.calcLoading(false)
        })
    },
    forgotPassword() {
      this.resetPasswordLoading = true
      const codeVerifier = randomstring.generate(128)
      localStorage.setItem('codeVerifier', codeVerifier)
      this.generateCodeChallenge(codeVerifier).then(challenge => {
        const currentLocale = this.$store.state.locale.currentLocale
        this.$store.commit('user/SET_POLICY', azureAD.forgotPasswordPolicy)
        window.open(
          `${azureAD.hostName}/${azureAD.tenantId}/oauth2/v2.0/authorize?p=${azureAD.forgotPasswordPolicy}&client_id=${azureAD.clientId}&nonce=defaultNonce&redirect_uri=${window.location.origin}/sign-in&scope=openid&response_type=code&prompt=login&ui_locales=${currentLocale}&code_challenge=${challenge}&code_challenge_method=S256`,
          '_self'
        )
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.auth-wrapper .register-form {
  .common-btn {
    width: 100%;
  }
}
</style>
